/*! mfac-story-led-pdp.js — WRITE theme. Fast-lane sticky + YOUR SELECTION price sync + gallery mock demote. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function moneyFromCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    var dollars = n / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        maximumFractionDigits: dollars % 1 === 0 ? 0 : 2,
      }).format(dollars);
    } catch (e) {
      var fixed = dollars % 1 === 0 ? String(Math.round(dollars)) : dollars.toFixed(2);
      return '$' + fixed;
    }
  }

  function readSelectedPrice(root) {
    var priceEl =
      (root && root.querySelector('[data-product-price]')) ||
      document.querySelector('[data-mfac-configure] [data-product-price], .mfac-configure [data-product-price]');
    if (priceEl) {
      var raw = (priceEl.getAttribute('content') || priceEl.textContent || '').replace(/[^\d.]/g, '');
      if (raw) {
        var dollars = parseFloat(raw);
        if (isFinite(dollars)) return Math.round(dollars * 100);
      }
    }
    var lane = document.querySelector('[data-mfac-fast-lane]');
    if (lane && lane.getAttribute('data-mfac-fast-lane-price')) {
      return Number(lane.getAttribute('data-mfac-fast-lane-price'));
    }
    return null;
  }

  function syncFastLanePrice(root) {
    var lane = document.querySelector('[data-mfac-fast-lane]');
    if (!lane) return;
    var cents = readSelectedPrice(root);
    if (cents == null || !isFinite(cents)) return;
    lane.setAttribute('data-mfac-fast-lane-price', String(cents));
    var money = moneyFromCents(cents);
    if (!money || true) return; /* PDP-PRICE-TOP 2026-10-15: no price in fast-lane */
    var mobile = lane.querySelector('[data-mfac-fast-lane-label]');
    var desk = lane.querySelector('[data-mfac-fast-lane-desktop]');
    if (mobile) mobile.textContent = 'YOUR SELECTION · ' + money + ' · Configure';
    if (desk) desk.textContent = 'YOUR SELECTION · ' + money + ' · Collect';
  }

  function demoteGalleryMockups(root) {
    var thumbs = root.querySelectorAll(
      '.product-single__thumbnails .product__thumb-item, .product__thumbs .product__thumb-item, [data-product-thumbs] .product__thumb-item, .product-single__thumbnail'
    );
    if (!thumbs.length) {
      thumbs = root.querySelectorAll('a.product__thumb, .product-single__thumbnail, [data-product-single-thumbnail]');
    }
    var mockRe = /in a room|showroom|bedroom|sofa|art-in-place|art in place/i;
    var keep = [];
    var demote = [];
    thumbs.forEach(function (el, idx) {
      if (idx === 0) {
        keep.push(el);
        return;
      }
      var alt = '';
      var img = el.querySelector('img');
      if (img) alt = img.getAttribute('alt') || img.getAttribute('aria-label') || '';
      if (!alt) alt = el.getAttribute('aria-label') || el.textContent || '';
      if (mockRe.test(alt)) {
        el.setAttribute('data-mfac-mock-thumb', '1');
        demote.push(el);
      } else {
        keep.push(el);
      }
    });
    if (!demote.length) return;
    var parent = keep[0] && keep[0].parentNode;
    if (!parent) return;
    demote.forEach(function (el) {
      parent.appendChild(el);
    });
  }

  function bindFastLane(root) {
    var lane = document.querySelector('[data-mfac-fast-lane]');
    var hero =
      document.querySelector('[data-mfac-artwork-stage] .mfac-artwork-stage__title') ||
      document.querySelector('[data-mfac-artwork-stage]') ||
      root.querySelector('.grid') ||
      root;
    var configure = document.getElementById('collect') || document.getElementById('configure');
    if (!lane || !configure) return;

    var heroGone = false;
    var inConfigure = false;

    function sync() {
      if (heroGone && !inConfigure) lane.removeAttribute('hidden');
      else lane.setAttribute('hidden', '');
    }

    if ('IntersectionObserver' in window) {
      var heroObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            heroGone = e.intersectionRatio < 0.05 || (!e.isIntersecting && e.boundingClientRect.top < 0);
          });
          sync();
        },
        { threshold: [0, 0.05, 0.2] }
      );
      heroObs.observe(hero);

      var cfgObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            inConfigure = e.isIntersecting && e.intersectionRatio > 0.15;
          });
          sync();
        },
        { threshold: [0, 0.15, 0.4] }
      );
      cfgObs.observe(configure);
    } else {
      function onScroll() {
        var hr = hero.getBoundingClientRect();
        var cr = configure.getBoundingClientRect();
        heroGone = hr.bottom < 80;
        inConfigure = cr.top < window.innerHeight * 0.7 && cr.bottom > 120;
        sync();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    syncFastLanePrice(root);
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.matches) return;
        if (t.matches('input[data-variant-input], input[type="radio"], select')) {
          setTimeout(function () {
            syncFastLanePrice(root);
          }, 50);
        }
      },
      true
    );
    if (typeof MutationObserver !== 'undefined') {
      var priceNode =
        root.querySelector('[data-product-price]') ||
        document.querySelector('[data-mfac-configure] [data-product-price]');
      if (priceNode) {
        var mo = new MutationObserver(function () {
          syncFastLanePrice(root);
        });
        mo.observe(priceNode, { childList: true, characterData: true, subtree: true });
      }
    }
  }

  ready(function () {
    var root = document.querySelector('[data-mfac-story-led-pdp]');
    if (!root) return;
    demoteGalleryMockups(root);
    bindFastLane(root);
  });
})();
